export const mgPlatformArrowBackIcon = {
  data: `<svg viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.45 5.37012H0.75" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/><path d="M4.75 1.37012L0.75 5.37012L4.75 9.37012" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-back'
}
